const state = {
  //DEMO演示，写死token
  token: window.sessionStorage.getItem("token") || window.localStorage.getItem("token"),
};

// getters
const getters = {};

// actions
const actions = {};

// mutations
const mutations = {
  login(state, payload) {
    state.token = payload.token;
    window.sessionStorage.setItem("token", payload.token);
    window.localStorage.setItem("token", payload.token);
  },
  logout(state) {
    state.token = null;
    window.sessionStorage.removeItem("token");
    window.localStorage.removeItem("token");
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
